import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Container, } from 'reactstrap';
import * as actions from '../actions/Courses';
import { getCourse } from '../actions/Course';
import List from '../components/course/List';
import Breadcrumb from '../components/AdminBreadcrumb';

class Courses extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            displayConfirmation: false,
            toDelete: []
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.currentSessionId !== prevState.currentSessionId) {
            if (nextProps.isCourseView)
                nextProps.actions.getCourses(nextProps.currentSessionId);
            else
                nextProps.actions.getSections(nextProps.currentSessionId);
        }
        return nextProps;
    }

    componentDidMount() {
        if (this.props.isCourseView)
            this.props.actions.getCourses(this.props.currentSessionId);
        else
            this.props.actions.getSections(this.props.currentSessionId);
    }

    handleSelect = (id) => {
        if (this.props.isCourseView) {
            this.props.actions.getCourse(id);
            this.props.history.push(`/courses/course/${id}`, { id })
        }
        else {
            this.props.actions.getCourse(id);
            this.props.history.push(`/sections/section/${id}`, { id })
        }
    };

    handleNew = () => {
        if (this.props.isCourseView) {
            this.props.actions.newCourse();
            this.props.history.push('/courses/course');
        }
        else {
            this.props.actions.newSection();
            this.props.history.push('/sections/section');
        }
    }

    handleDelete = (ids) => this.props.isCourseView ? this.props.actions.deleteCourses(this.props.currentSessionId, ids) : this.props.actions.deleteSections(this.props.currentSessionId, ids);

    render() {
        return (
            <Container>
                <Breadcrumb history={this.props.history} />
                <List
                    className='pb-1'
                    title={this.props.isCourseView ? 'Courses' : 'Sessions'}
                    hideSearchButton={true}
                    courses={this.props.courses}
                    onDelete={this.handleDelete}
                    onSelect={this.handleSelect}
                    onAdd={this.handleNew}
                />
            </Container>
        );
    }
}

function mapStateToProps(state, ownProps) {

    return {
        courses: state.Courses,
        isCourseView: ownProps.location.pathname === "/courses"
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...actions , getCourse}, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Courses);